import { render } from "./base-modal.vue?vue&type=template&id=cd696d46&ts=true"
import script from "./base-modal.vue?vue&type=script&lang=ts"
export * from "./base-modal.vue?vue&type=script&lang=ts"

import "./base-modal.vue?vue&type=style&index=0&id=cd696d46&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__